import { __awaiter, __generator } from "tslib";
import { openDB } from 'idb';
export function getDB(dbName, onOpen, version) {
    if (version === void 0) { version = 1; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, openDB(dbName, version, onOpen)];
        });
    });
}
export function writeAll(db, records, storeName, writeBehavior, keys) {
    return __awaiter(this, void 0, void 0, function () {
        var transaction, writes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(writeBehavior === 'replace')) return [3 /*break*/, 2];
                    return [4 /*yield*/, db.clear(storeName)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    transaction = db.transaction(storeName, 'readwrite');
                    writes = records.map(function (record, index) {
                        var key = keys[index];
                        return transaction.store.put(record, key);
                    });
                    return [4 /*yield*/, Promise.all(writes)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, transaction.done];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function read(db, storeName, key) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, db.get(storeName, key)];
        });
    });
}
export function readAll(db, storeName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, db.getAll(storeName)];
        });
    });
}
export function readNByIndex(db, storeName, indexName, count, reverse) {
    if (reverse === void 0) { reverse = false; }
    return __awaiter(this, void 0, void 0, function () {
        var index, cursor, results, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    index = db.transaction(storeName, 'readonly').store.index(indexName);
                    return [4 /*yield*/, index.openCursor(undefined, reverse ? 'prev' : 'next')];
                case 1:
                    cursor = _a.sent();
                    results = [];
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < count && cursor)) return [3 /*break*/, 5];
                    results.push(cursor.value);
                    return [4 /*yield*/, cursor.continue()];
                case 3:
                    cursor = _a.sent();
                    _a.label = 4;
                case 4:
                    i++;
                    return [3 /*break*/, 2];
                case 5: return [2 /*return*/, results];
            }
        });
    });
}
export function deleteItem(db, storeName, key) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, db.delete(storeName, key)];
        });
    });
}
//# sourceMappingURL=IDBCache.js.map